<template>
  <div class="main-block">
    <div class="main-lot-image-block">
      <swiper
        v-if="files?.length > 1"
        class="images-swiper-navigation"
        direction="vertical"
        :slides-per-view="'auto'"
        :navigation="true"
        type="lotGallery">
        <swiper-slide class="navigation-image" v-for="(file, index) in files" :key="index">
          <img v-if="file.type === LotFileTypes.IMAGE" :src="file.src" alt="lot" />
          <img
            v-else-if="file.type === LotFileTypes.PDF"
            :src="auctionStore.filePlaceholders.pdf_min"
            class="mini-video-placeholder"
            alt="lot" />
          <img
            v-else-if="file.type === LotFileTypes.VIDEO"
            :src="auctionStore.filePlaceholders.video"
            class="mini-video-placeholder"
            alt="lot" />
          <img v-else :src="auctionStore.filePlaceholders.no_image" alt="lot" />
        </swiper-slide>
      </swiper>

      <div class="main-lot-image">
        <swiper
          thumbs-swiper=".images-swiper-navigation .swiper-wrapper"
          :slides-per-view="1"
          :navigation="false"
          :allow-touch-move="false"
          type="lotGalleryMain">
          <swiper-slide class="swiper-slide" v-for="(file, index) in files" :key="index">
            <template v-if="file.type === LotFileTypes.IMAGE">
              <div class="magnifier-zoom-image">
                <img class="magnifier-image" :src="file.src" alt="lot" />
                <div class="magnifier-zone" :data-magnifier-src="file.src"></div>
              </div>
            </template>
            <template v-else-if="file.type === LotFileTypes.PDF">
              <a :href="file.src" class="magnifier-zoom-image" target="_blank">
                <img :src="auctionStore.filePlaceholders.pdf" alt="lot" class="pdf-placeholder" />
              </a>
            </template>
            <template v-else-if="file.type === LotFileTypes.VIDEO">
              <video-player-custom
                class="custom-video-player magnifier-zoom-image"
                :video-src="file.src"
                title="lot"></video-player-custom>
            </template>
            <template v-else>
              <img class="magnifier-image" :src="auctionStore.filePlaceholders.no_image" alt="lot" />
            </template>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <card-info-block v-if="lot?.id" @close-form="emit('closeForm')"></card-info-block>
  </div>
</template>

<script lang="ts" setup>
  import { computed, defineProps, onMounted, onUnmounted } from "vue";
  import Swiper from "@/components/_partials/Swiper.vue";
  import VideoPlayerCustom from "@/components/_partials/VideoPlayerCustom.vue";
  import CardInfoBlock from "@/components/CardInfoBlock.vue";
  import { LotFileTypes } from "@/enum";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ILotPopupData } from "@/models";

  const emit = defineEmits(["closeForm", "changeTitle", "setModalHeightAuto"]);

  const auctionStore = useAuctionStore();
  const lot = computed(() => auctionStore.popupLot as ILotPopupData);
  const files = computed(() => lot.value?.files);

  const props = defineProps<{
    lotProp: ILotPopupData;
  }>();

  onMounted(() => {
    auctionStore.$patch((state) => {
      state.popupLot = props.lotProp;
    });
  });

  onUnmounted(() => {
    auctionStore.$patch((state) => {
      state.popupLot = null;
    });
  });
</script>
